export default __webpack_public_path__ + "static/media/rotate-left.5a8ad040.svg";